__turbopack_context__.v({
  "button": "_6Nr3pG_button",
  "column": "_6Nr3pG_column",
  "container": "_6Nr3pG_container",
});
